import { ActiveMergeSuggestion } from '@modules/taxonomy/store/types';
import { useChartTooltipStore } from './useChartTooltipStore';
import { Category } from '@modules/common/types';

export const useMergeSuggestions = () => {
  const setData = useChartTooltipStore(({ setData }) => setData);

  const onUpdateSuggestedName = (suggestedName: string) => {
    setData((prev) => {
      if (!prev || !prev.activeMergeSuggestion) {
        return prev;
      }

      return {
        ...prev,
        activeMergeSuggestion: {
          ...prev.activeMergeSuggestion,
          suggestedName: suggestedName,
        },
      };
    });
  };

  const onUpdateCategory = (category: Category) => {
    setData((prev) => {
      if (!prev || !prev.activeMergeSuggestion) {
        return prev;
      }

      return {
        ...prev,
        activeMergeSuggestion: {
          ...prev.activeMergeSuggestion,
          category,
        },
      };
    });
  };

  const onAddSuggestion = ({
    id,
    label,
    category,
  }: ActiveMergeSuggestion['suggestedLabelsToMerge'][number]) => {
    setData((prev) => {
      if (!prev || !prev.activeMergeSuggestion) {
        return prev;
      }

      return {
        ...prev,
        activeMergeSuggestion: {
          ...prev.activeMergeSuggestion,
          suggestedLabelsToMerge: prev.activeMergeSuggestion
            ?.suggestedLabelsToMerge
            ? [
                ...prev.activeMergeSuggestion.suggestedLabelsToMerge,
                { label, id, category },
              ]
            : [{ label, id, category }],
        },
      };
    });
  };

  const onRemoveSuggestion = (id: string) => {
    setData((prev) => {
      if (!prev || !prev.activeMergeSuggestion) {
        return prev;
      }

      return {
        ...prev,
        activeMergeSuggestion: {
          ...prev.activeMergeSuggestion,
          suggestedLabelsToMerge:
            prev.activeMergeSuggestion?.suggestedLabelsToMerge.filter(
              (suggestion) => suggestion.id !== id,
            ),
        },
      };
    });
  };

  return {
    onUpdateSuggestedName,
    onUpdateCategory,
    onAddSuggestion,
    onRemoveSuggestion,
  };
};
